import { Button, PasswordInput, RefBool, Snack, TextInput } from "@tblabs/truffle";
import { Page } from "./Page";
import { PrimaryButton } from "../Components/PrimaryButton";
import { Center } from "../Components/Center";
import { InfoBox } from "../Components/InfoBox";
import { LoginFormLogic } from "../Services/Auth/LoginLogic";
import { OnlineStorage } from "@tblabs/storage";
import { StorableSelect } from "../Components/StorableSelect";


export class LoginPage extends Page
{
    private pingInProgress = new RefBool();

    constructor(
        private _formLogic: LoginFormLogic,
        private _storage: OnlineStorage,
        private databaseFromUrl?: string,
        private userFromUrl?: string,
        private passwordFromUrl?: string)
    {
        super("Login");
    }

    protected async OnAppend(): Promise<void>
    {
        const server = new StorableSelect(this._formLogic.ServerInput, "servers");
        const database = new StorableSelect(this._formLogic.DatabaseInput, "databases").MarginTop(8);

        if (this.databaseFromUrl)
            this._formLogic.DatabaseInput.value = this.databaseFromUrl;

        const userInput = new TextInput(this._formLogic.LoginInput).Placeholder("User").MarginTop(8);

        if (this.userFromUrl)
            this._formLogic.LoginInput.value = this.userFromUrl;

        const passwordInput = new PasswordInput(this._formLogic.PasswordInput).ShowPasswordOnTouch().MarginTop(8)
            .Placeholder("Password").TogglePasswordView()
            .OnEnterKeyPressed(async () => await this._formLogic.TryLogin())

        if (this.passwordFromUrl)
            this._formLogic.PasswordInput.value = this.passwordFromUrl;

        const loginButton = new PrimaryButton("Login").MarginTop(8)
            .Disable(this._formLogic.LoginInProgress)
            .OnClick(async () => await this._formLogic.TryLogin())

        this.body.MaxWidth(400).Append(
            server,
            database,
            userInput,
            passwordInput,
            new Center(
                new Button("Ping server").MarginTop(8).MarginRight(8)
                    .Disable(this.pingInProgress)
                    .OnClick(async () => await this.PingServer()),
                loginButton,
                "\n",
                new InfoBox("Problem", this._formLogic.ErrorMessage)
                    .Visible(this._formLogic.ErrorMessageVisible),
            )
        );
    }

    private async PingServer(): Promise<void>
    {
        if (this.pingInProgress.value) return;

        this.pingInProgress.True();

        this._storage.SetServer(this._formLogic.ServerInput.value);
        const response = await this._storage.Ping();

        this.pingInProgress.False();

        new Snack("Server status", response ? "✅ Server is online" : "❌ Server is offline");
    }
}